export const SPOTIFY_REDIRECT_URL = 'https://ytneu.github.io/musi-memo/user';
export const LOCAL_REDIRECT_URL = 'http://localhost:3000/user';
